var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterClean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.243 2.619a.83.83 0 000 1.174l2.125 2.125c.041.09.094.177.16.256l5.084 6.195v2.195c0 .305.11.556.333.722l1.778 1.334a.959.959 0 00.945.083.866.866 0 00.5-.806v-1.18l3.607 3.607a.83.83 0 101.174-1.174L3.417 2.62a.83.83 0 00-1.174 0zm15.981 3.555l-4.007 4.91L7.474 4.34h9.916c.417 0 .806.25 1 .64.167.388.112.86-.166 1.194z"
  })));
}
export default SvgFilterClean;